export default "__VITE_ASSET__22665276__"